const svgToDataURL = require('svg-to-dataurl');

export function toBase64(svgStr) {
  return svgToDataURL(svgStr);
}
